// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"5ac2992c","782":"125e89cc"}[chunkId] + ".chunk.css";
};